(function($){

	let openCallForm = $('#bar-lu-opencall-form');

	if(!openCallForm || openCallForm.length < 1){
		return;
	}

	
	let buttons = $('[href="https://portal.r2docuo.com/barrabes-turismo/forms/reg"]');
	let closeButton = $('.bar-lu-opencall-pop-up__close');





	closeButton.click(function(e){
		e.preventDefault();
		$('.bar-lu-opencall-pop-up').removeClass( 'bar-lu-opencall-pop-up--is-visible' );
	})



	buttons.click( function(e){
		e.preventDefault();
		$('.bar-lu-opencall-pop-up').addClass( 'bar-lu-opencall-pop-up--is-visible' );
	} );



	openCallForm.validate({

        ignore: [],
        rules: {
        	"bar-lu-opencall-form-name" : {
	            required: true,
	        },
			"bar-lu-opencall-form-email" : {
	            required: true,
	            email: true,
	        },
	        "acceptance" : {
	            required: true,
	        },
        },
        errorPlacement: function(error, element) {
            error.appendTo( $(element).closest(".bar-form-field").find('.bar-form-feedback') );
        },
        highlight: function(element) {
            $(element).closest(".bar-form-field").addClass('bar-form-field--has-error');
        },
        unhighlight: function(element) {
            $(element).closest(".bar-form-field").removeClass('bar-form-field--has-error');
        },

        submitHandler: function(form){

            $.ajax({
		        type: "POST",
		        dataType: "json",
		        url: var_bar_ajax.url,
		        data: {
		        	action : var_bar_ajax.action,
					nonce: var_bar_ajax.nonce,
					callback: 'bar-send-opencall-form',
					formData: $(form).serialize(),
		        },
		        success: function(response){

		        	if(response === 'OK'){
		        		window.location.href = 'https://portal.r2docuo.com/barrabes-turismo/forms/reg';
		        	}else{
		        		openCallForm.find('.bar-alert').html(response);
		        	}		        	
		        },
		        error : function(jqXHR, textStatus, errorThrown) {
		        	console.log('Error desconocido');
		        	console.log(errorThrown);
		        	openCallForm.find('.bar-alert').html('Unknown error');
		        }

		    }); // $.ajax
        }
    });

})(jQuery)